import { CommonTooltips } from "@mcleod/common";
import { ModelRow } from "@mcleod/core";

export class ContactVerificationUtil {

    public static updateVerificationImage(contactRow: ModelRow, verificationImage, useOverride = false) {
        if (contactRow == null) {
            verificationImage.visible = false;
            return;
        }
        if (contactRow?.get("verification_status") != null) {
            verificationImage.visible = true;
            if (useOverride) {
                CommonTooltips.setTooltipContentLayout(verificationImage, contactRow, "lme/dispatch/ContactVerificationQuickInfo");
            } else {
                CommonTooltips.setTooltipContentLayout(verificationImage, contactRow.get("id"), "lme/dispatch/ContactVerificationQuickInfo");
            }
        }
        switch (contactRow?.get("verification_status")) {
            case "A":
                verificationImage.color = "success";
                break;
            case "V":
                verificationImage.color = "success";
                break;
            case "U":
                verificationImage.color = "warning";
                break;
            case "N":
                verificationImage.color = "error";
                break;
            default:
                verificationImage.visible = false;
                break;
        }
    }

}
